import {
  getIndexHighSeas,
  getHighSeasList,
  getHighSeasCustomerInfo,
  salvageOrdero,
  getAwaitVisitList,
  getCustomerInfo,
  customerFollow,
  getLoseReasonList,
  getFollowTypeList
} from '@/api/internationalWater'
const state = {

}
const mutations = {

}
const actions = {
  // 01-首页（公海池数据）
  getIndexHighSeas(temp, data) {
    return new Promise((resolve, reject) => {
      getIndexHighSeas(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 02-公海池列表
  getHighSeasList(temp, data) {
    return new Promise((resolve, reject) => {
      getHighSeasList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-公海池客户详情
  getHighSeasCustomerInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getHighSeasCustomerInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 04-捞单
  salvageOrdero(temp, data) {
    return new Promise((resolve, reject) => {
      salvageOrdero(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 05-公海池预面谈列表
  getAwaitVisitList(temp, data) {
    return new Promise((resolve, reject) => {
      getAwaitVisitList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 06-客户详情
  getCustomerInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getCustomerInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 跟进
  customerFollow(temp, data) {
    return new Promise((resolve, reject) => {
      customerFollow(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 输单原因标签列表
  getLoseReasonList(temp, data) {
    return new Promise((resolve, reject) => {
      getLoseReasonList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 跟进方式列表
  getFollowTypeList(temp, data) {
    return new Promise((resolve, reject) => {
      getFollowTypeList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
